<template>
  <v-app >
    <AppBarPublic color="primary100" />
    <v-main class="">
     <transition>
       <keep-alive>
        <router-view  />
       </keep-alive>
      </transition>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import AppBarPublic from "@/components/public/AppBarPublic";
import Footer from "@/components/public/Footer";
export default {
  components: {
    Footer,
    AppBarPublic
  }
};
</script>
